/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleOvertimeReportRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {SimpleOvertimeReportResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const simpleOvertimeReport = (request: SimpleOvertimeReportRequest, options?: CashRequestOptions) => post<SimpleOvertimeReportRequest, SimpleOvertimeReportResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/SimpleOvertimeReport", request, {...options, rejectOnError: true })